"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderScreenHeader = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var __1 = require("../../");
var Theme_1 = require("../../Theme");
var HeaderScreenContent_1 = require("./HeaderScreenContent");
var Header = styled_components_1.default.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex: 0 0 90px;\n    border-bottom: 1px solid #DDE5ED;\n"], ["\n    flex: 0 0 90px;\n    border-bottom: 1px solid #DDE5ED;\n"])));
var Caption = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 20px;\n    font-weight: bold;\n"], ["\n    color: ", ";\n    font-size: 20px;\n    font-weight: bold;\n"])), Theme_1.Color.Grey.G80);
Caption.displayName = "Caption";
var Container = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n    color: ", ";\n"], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n    color: ", ";\n"])), Theme_1.Color.Grey.G80);
var Button = styled_components_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n   border: 0;\n   background-color: transparent;\n   cursor: pointer;\n   color: ", ";\n   transition: all ease 0.25s;\n\n   &:hover {\n       color: black;\n   }\n\n   &:active {\n       transform: scale(0.8);\n   }\n"], ["\n   border: 0;\n   background-color: transparent;\n   cursor: pointer;\n   color: ", ";\n   transition: all ease 0.25s;\n\n   &:hover {\n       color: black;\n   }\n\n   &:active {\n       transform: scale(0.8);\n   }\n"])), Theme_1.Color.Grey.G70);
var HeaderScreenHeader = /** @class */ (function (_super) {
    __extends(HeaderScreenHeader, _super);
    function HeaderScreenHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderScreenHeader.prototype.render = function () {
        return (React.createElement(Header, null,
            React.createElement(HeaderScreenContent_1.HeaderScreenContent, null,
                React.createElement(Container, null,
                    React.createElement(Caption, { role: "heading", "aria-level": 1 }, this.props.Caption),
                    React.createElement(Button, { type: "button", "aria-label": "Close Window", onClick: this.props.OnCloseRequest },
                        React.createElement(__1.CloseThinIcon, { Height: "24px", Width: "24px" }))))));
    };
    return HeaderScreenHeader;
}(React.Component));
exports.HeaderScreenHeader = HeaderScreenHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
